import React from "react";
import {Typography} from "@mui/material";

const labelStyle = {
    display: "list-item",
    marginLeft: "1.5rem"
};

export default function TagsList({tagList}) {

    return <>
        {
          tagList.length === 0
          &&
          <Typography variant="body2" sx={labelStyle}>No Feedback</Typography>
        }

        {
          tagList.length > 0
          &&
          tagList.map((value, id) => (<Typography key={id} variant="body2" sx={labelStyle}>{value}</Typography>))
        }
    </>;
}